// Import Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Import Utilities
import { isArrayWithLength, getClassNames } from '../../../utils';

const Checkbox = ({
  options, name, value, handleChange, isDark, ...props
}) => (
  <div>
    {isArrayWithLength(options)
      && options.map((option) => {
        if (!option.id && !option.label) return null;

        const selected = isArrayWithLength(value) && (
          value.includes(String(option.id)) || value.includes(String(option.label))
        );

        return (
          <div
            className={getClassNames(props, 'c-form-checkbox', {
              'c-form-checkbox--dark': isDark,
            })}
            key={option.id}
          >
            <input
              className="c-form-checkbox__input"
              type="checkbox"
              onChange={(e) => handleChange(e)}
              checked={selected}
              name={name}
              id={`${(name === 'time' ? option.label : option.id)}`}
              value={option.value || undefined}
            />

            <label className="c-form-checkbox__label" htmlFor={`${(name === 'time' ? option.label : option.id)}`}>
              {option.label}
            </label>
          </div>
        );
      })}
  </div>
);

Checkbox.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  })).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  isDark: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
  value: null,
  isDark: false,
};

export default Checkbox;
